<template>
  <info-hint variant="neutral" icon="icon-calendar-60">
    Showing only booked slots · {{ label }}
    <base-button link type="primary" size="sm" class="booking-range-banner__switch p-0 ml-2" @click="emit('switch-to-day')">
      Switch to day view to see all slots
    </base-button>
  </info-hint>
</template>

<script setup lang="ts">
// Shared multi-day banner for the booking views (OTC-166)
defineProps({
  label: { type: String, required: true }
})
const emit = defineEmits<{ (e: 'switch-to-day'): void }>()
</script>

<script lang="ts">
export default { name: 'BookingRangeBanner' }
</script>

<style scoped>
/* The theme button is larger than the hint's 12px text and made the row taller, pushing the
   icon and label up; the link takes the hint's own type so everything sits on one line */
.booking-range-banner__switch {
  margin-top: 0;
  margin-bottom: 0;
  font-size: inherit;
  line-height: inherit;
  vertical-align: baseline;
}
</style>
